import ApiService from "@/common/api/api.service";

const AutenticacaoService = {
  logar(form) {
    return ApiService.post(`Autenticacao/autenticar`, {
      ...form,
    });
  },
  validarToken() {
    return ApiService.get(`Autenticacao/token-valido`);
  },
  invalidarToken() {
    return ApiService.put(`Autenticacao/invalidar-token`);
  },
  regeraTokenPorEmpresa(form) {
    return ApiService.put(`Autenticacao/regerar-token-por-empresa`, {
      ...form,
    });
  }
};

export default AutenticacaoService;
